import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  inject,
} from '@angular/core';

import { once } from '@web/utils';
import { HttpErrorService } from '@web/common';
import { AlertsComponent, AlertsService } from '@web/shared/ui';
import { HttpErrorResponse } from '@angular/common/http';
import { WarehouseReleaseFormData } from '../../models/warehouse-release-form-data';
import { WarehouseReleaseDataSourceService } from '../../services/warehouse-release-data-source.service';
import { WarehouseReleaseFormComponent } from '../../components/warehouse-release-form/warehouse-release-form.component';

@Component({
  selector: 'app-warehouse-release-create',
  imports: [AlertsComponent, WarehouseReleaseFormComponent],
  templateUrl: './warehouse-release-create.component.html',
  styleUrl: './warehouse-release-create.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AlertsService],
})
export class WarehouseReleaseCreateComponent {
  /* prettier-ignore */
  private readonly warehouseReleaseDataSource = inject(WarehouseReleaseDataSourceService);
  private readonly httpError = inject(HttpErrorService);
  private readonly alerts = inject(AlertsService);

  public readonly fileUploadVisibility = input(false);
  public readonly submitSuccessEvent = output();

  public handleSubmitSuccessEvent(data: WarehouseReleaseFormData): void {
    this.warehouseReleaseDataSource
      .createByFormData(data)
      .pipe(once())
      .subscribe({
        next: () => {
          this.notifySubmitSuccessEvent();
        },
        error: (response) => this.showFailureAlertByResponse(response),
      });
  }

  private notifySubmitSuccessEvent(): void {
    this.submitSuccessEvent.emit();
  }

  private showFailureAlertByResponse(response: HttpErrorResponse): void {
    this.alerts.showMultiple((builder) =>
      this.httpError
        .extract(response)
        .messages()
        .map((message) => builder.buildFailure(message)),
    );
  }
}
